import type { ReactNode } from 'react'

import type { Interpolation, Theme } from '@emotion/react'
import { useTheme } from '@emotion/react'

import { useScrollPosition } from '@twistopayments/design-system/hooks'

import * as styles from './app-bar.styles'

type Props = {
  children?: ReactNode
  variant?: keyof typeof styles.variants
  className?: string
  css?: Interpolation<Theme>
}

export const AppBar = ({
  children,
  variant = 'contained',
  className,
  css: cssProp,
}: Props) => {
  const theme = useTheme()
  const scrollY = useScrollPosition()

  const css = [
    styles.root(theme),
    styles.variants[variant](theme),
    (variant === 'contained' || (variant === 'fixed' && scrollY > 0)) &&
      styles.shadow(theme),
    cssProp,
  ]

  return (
    <div className={className} css={css} data-testid="app-bar">
      {children}
    </div>
  )
}
